module.exports = __webpack_public_path__ + "img/no-data-default.d95e9bdd.svg";